resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';// Added function to the dot container
// the function gets icon from a json and adds into class
// you will need to follow the structure for this to work as seen on product-pages
// also to enable you should add (data-use-icon="true") in the container

function ContentPaneGroup() {
  this.extends = [_ResponsiveLayout, _ContentLayout];
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.priority = 1100;

  // Parameters
  this.paneConfig = {
    desktop: 3,
    tablet: 2,
    mobile: 1
  };

  this.parentClasses = [
    "row"
  ];

  this.timer = 10000;
  this.autoRotate = false;
  this.hint = true;
  this.arrows = true;
  this.dots = true;
  this.numerics = false;
  this.svgDots = false;
  this.circular = true;
  this.preserveUI = false;
  this.onMoveEnd = function (position) {};
  this.hintSpacing = "50px";
  this.default = 0;
  this.leftArrowAnalytics = "";
  this.rightArrowAnalytics = "";


  // Vars
  this._innerContainer = null;
  this._contentContainer = null;
  this._touch = false;
  this._position = 0;
  this._maxPosition = null;
  this._currentPaneSize = null;
  this._currentLayout = null;
  this._nodeList = null;
  this._arrowsContainer = null;
  this._dotsContainer = null;
  this._rotateTimeout = null;

  this._ratios = {
    desktop: 0,
    tablet: 0,
    mobile: 0
  };


  this._touchStats = {
    x_orig: null,
    y_orig: null,
    margin_orig: null,
    x_current: null,
    y_current: null,
    direction: null
  };

  this._classes = {
    container: "mogo-ui-content-pane-group",
    inner: "mogo-ui-content-pane-group-inner",
    content: "content-container",
    numerics: "numerics",
    dots: "dots",
    mod_numerics: "mogo-ui-content-pane-group--numerics",
    mod_dots: "mogo-ui-content-pane-group--dots",
    mod_arrows: "mogo-ui-content-pane-group--arrows",
    mod_circle_arrows : "mogo-ui-content-pane-group--circle-arrows",
  };

  this.destroy = function() {};
  this.init = function() {
    // Detect touch
    if ($("html.touch").length > 0) {
      this._touch = true;
    }

    // Parse pane config parameters
    if (typeof this.paneConfig == "string") {
      this.paneConfig = eval( "(" + this.paneConfig + ")" );
    }

    // Parse pane config parameters
    if (typeof this.parentClasses == "string") {
      this.parentClasses = eval( "(" + this.parentClasses + ")" );
    }

    // Create outer container, content container
    this._contentContainer = $("<div>").addClass(this._classes.content);
    this._innerContainer = $(this.node);

    this._innerContainer.addClass(this._classes.inner);

    this.$node = $("<div>").addClass(this._classes.container).addClass(this.parentClasses.join(' ')).insertBefore(this._innerContainer);

    this._contentContainer.appendTo(this.$node);
    this._innerContainer.appendTo(this._contentContainer);

    //circle arrows

    //Accessibility
    this.$node.attr("aria-live","polite").attr("aria-atomic", "true");
    this._innerContainer.attr("tabindex", "0");
    this._innerContainer.on("keydown", this._handleKeyDownEvents.bind(this));

    // Hint
    if (this.hint) {
      this._innerContainer.css("padding-left", this.hintSpacing);
      this._innerContainer.css("padding-right", this.hintSpacing);
    }

    // Create arrows container
    this._arrowsContainer = $("<div class='arrows'><a href='#' class='left' title='previous' aria-controls=" + this.id + " data-analytics-id=" + this.leftArrowAnalytics + "><span class='arrow-hollow-left'></span></a><a href='#' class='right' title='next' aria-controls=" + this.id + " data-analytics-id=" + this.rightArrowAnalytics + "><span class='arrow-hollow-right'></span></a></div>");
    this._arrowsContainer.appendTo(this._contentContainer);

    // Create numerics container
    this._numericsContainer = $("<div>").addClass(this._classes.numerics);
    this._numericsContainer.appendTo(this.$node);


    this.$node.
      toggleClass(this._classes.mod_arrows, this.arrows).
      toggleClass(this._classes.mod_numerics,this.numerics);

    //Get the current layout
    this.activeRange();
    this._currentLayout = this.smallRange? "mobile" : this.mediumRange? "tablet" : "desktop";

    // Setup content based on pane config parameters
    this._setupContent();

    // Connections
    $(".arrows .left", this.$node).on("click", $.proxy(this.moveLeft, this));
    $(".arrows .right", this.$node).on("click", $.proxy(this.moveRight, this));

    // prevent double rotate from timer executing right before click
    $(".arrows .left", this.$node).on("mouseover", $.proxy(this._autoRotateInit, this));
    $(".arrows .right", this.$node).on("mouseover", $.proxy(this._autoRotateInit, this));

    if (this._touch) {
      this.$node.on("touchstart", $.proxy(this._onTouchStart, this));
      this.$node.on("touchmove", $.proxy(this._onTouchMove, this));
      this.$node.on("touchend", $.proxy(this._onTouchEnd, this));
    }

    // Show container
    this._innerContainer.css("display", "block");
    this._moveToPosition(this.default);

    // start auto rotate if not set to only rotate once viewed
    this._autoRotateInit();
  };

  this._autoRotateInit = function() {
    if(this.autoRotate) {
      clearTimeout(this._rotateTimeout);
      this._rotateTimeout = setTimeout($.proxy(this._rotate, this), this.timer);
    }
  };

  this._rotate = function() {
    this.moveRight();
    this._autoRotateInit();
  };

  this.initAllReady = function() {
    // Register responsive functions
    this.registerResponsiveFunction($.proxy(this.resize, this, "mobile"), null,
      mogo.registry.mogoUI.config.mediaQueries.small);

    this.registerResponsiveFunction($.proxy(this.resize, this, "tablet"),
      mogo.registry.mogoUI.config.mediaQueries.small + 1, mogo.registry.mogoUI.config.mediaQueries.medium);

    this.registerResponsiveFunction($.proxy(this.resize, this, "desktop"),
      mogo.registry.mogoUI.config.mediaQueries.medium + 1, null);
  };

  this.moveLeft = function() {
    if (this._position > 0) {
      this._moveToPosition(this._position - 1);

    } else if (this.circular) {
      this._moveToPosition(this._maxPosition);
    }

    // reset autoRotate Timer to prevent the timer from rotating after the user clicks
    this._autoRotateInit();
    return false;
  };

  this.moveRight = function() {
    if (this._position < this._maxPosition) {
      this._moveToPosition(this._position + 1);

    } else if (this.circular) {
      this._moveToPosition(0);
    }

    // reset autoRotate Timer to prevent the timer from rotating after the user clicks
    this._autoRotateInit();
    return false;
  };

  this.resize = function(type, width) {
    // Setup variables
    this._currentLayout = type;

    // Setup content
    this._setupContent();

    // Reset heights
    for (var i = 0; i < this._nodeList.length; i++) {
      $(this._nodeList[i]).css("height", "auto");
      $(this._nodeList[i]).css("top", "0");
    }

    // Dots visible
    if (this._nodeList.length <= this.paneConfig[type]) {
      $(this._dotsContainer).css("display", "none");

    } else if (this.dots) {
      $(this._dotsContainer).css("display", "block");
    }

    // Arrows visible
    if (this._nodeList.length <= this.paneConfig[type]) {
      $(this._arrowsContainer).css("display", "none");

    } else if (this.arrows) {
      $(this._arrowsContainer).css("display", "block");
    }

    // Hint enabled
    if (this._nodeList.length <= this.paneConfig[type]) {
      this._innerContainer.css("padding-left", "0px");
      this._innerContainer.css("padding-right", "0px");

    } else if (this.hint) {
      this._innerContainer.css("padding-left", this.hintSpacing);
      this._innerContainer.css("padding-right", this.hintSpacing);
    }

    // Relayout children
    this.reLayoutChildren();

    // Find max heights
    var maxHeight = 0;
    for (i = 0; i < this._nodeList.length; i++) {
      maxHeight = Math.max(maxHeight, $(this._nodeList[i]).height());
    }

    // Set max height, position elements
    this._innerContainer.css("height", maxHeight + "px");

    for (i = 0; i < this._nodeList.length; i++) {
      $(this._nodeList[i]).css("height", maxHeight + "px");
      $(this._nodeList[i]).css("top", -$(this._nodeList[i]).position().top + "px");
    }

    // Set current pane size
    this._currentPaneSize = $(this._nodeList[0]).width();
  };

  this._setupContent = function() {
    var contentAppend = $(".feature-controls-js");

    // Setup node list
    this._nodeList = this._innerContainer.children().filter(function(){
      return $(this).css("display") != "none";
    });

    for (i = 0; i < this._nodeList.length; i++) {
      var curNode = this._nodeList[i];
      $(curNode).addClass("content-pane columns");

      if (i === 0) {
        $(curNode).css("margin-left", "0%");
      }

      if (i == this._nodeList.length - 1) {
        $(curNode).addClass("end");
      }
    }

    this._calculateColumns();
    this._maxPosition = this._nodeList.length - this.paneConfig[this._currentLayout];

    // Create dots container
    if (this._dotsContainer) this._dotsContainer.remove();

    this._dotsContainer = $("<div class='dots'></div>");
    $(this._dotsContainer).appendTo(this.$node);

    if (this.dots) {
      $(this._dotsContainer).css("display", "block");
    }

    for (i = 0; i < this._nodeList.length; i++) {
      var controlClass = null;
      var temp;

      if (contentAppend.data('use-icon')){
        if (!this.svgDots) {
          temp = $("<a class='dot " + $(this._nodeList[i]).data('icon') + "' data-target='" + $(this._nodeList[i]).attr('id') + "'></a>");
        }
        else {
          temp = $("<a class='dot' data-target='" + $(this._nodeList[i]).attr('id') + "'><svg viewBox='0 0 32 32' class='svg-icon nav-menu__icon'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#" +$(this._nodeList[i]).data('icon')+"'></use></svg></a>");
        }

        temp.attr("title", (i + 1) +  " of " + (this._maxPosition + 1)).
          appendTo(this._dotsContainer).
          on("click", $.proxy(this._moveToPosition, this, i));
      }
    }

    this._dotsList = $(".dots .dot", this.$node);
    $(this._dotsList[this._position]).addClass("selected").attr("aria-selected", "true");

    // Hide unnecessary dots
    for (i = 0;i < this._dotsList.length; i++) {
      if (i <= this._maxPosition) {
        $(this._dotsList[i]).css("display", "");

      } else {
        $(this._dotsList[i]).css("display", "none");
      }
    }

    // Move to current position
    if (this._position > this._maxPosition) {
      this._position = this._maxPosition;
    }

    var margin = (this._position * this._ratios[this._currentLayout]) * 100;

    $(this._nodeList[0]).animate({
      "margin-left": -margin + "%"
    }, {
      queue: false,
      duration: 250,
      easing: "easeOutQuad"
    });
  };

  this._handleKeyDownEvents = function(e) {
    if (e.which >= 37 && e.which <= 40) {
      // Handle key events that are up/down/left/right

      // Stop event propagation
      e.preventDefault();

      if (e.which == 37 || e.which == 38) {
        // Left/up arrow
        this.moveLeft();
      } else if (e.which == 39 || e.which == 40) {
        // Right/down arrow
        this.moveRight();
      }
    }
  };

  this._moveToPosition = function(pos) {
    this._position = pos;
    var margin = (this._position * this._ratios[this._currentLayout]) * 100;

    $(this._nodeList[0]).animate(
      {
        "margin-left": -margin + "%"
      }, {
        queue: false,
        duration: 500,
        easing: "easeOutQuad"
      });

    this._updateDisplay();

    return false;
  };

  this._updateDisplay = function() {
    for (i = 0; i < this._nodeList.length; i++) {
      $(this._nodeList[i]).
        attr("aria-selected", i === this._position).
        attr("aria-hidden", i !== this._position);
    }

    this._numericsContainer.html((this._position + 1) + " / <span class='a11y__hidden-content'> of </span>" + (this._maxPosition + 1));

    $(this._dotsList).removeClass("selected").removeAttr("aria-selected");
    $(this._dotsList[this._position]).addClass("selected").attr("aria-selected", "true");

    if (!this.circular || (this._touch && !this.preserveUI)) {
      if (this._position === 0) {
        $(".left", this._arrowsContainer).css("display", "none");
        $(".right", this._arrowsContainer).css("display", "block");

      } else if (this._position == this._maxPosition) {
        $(".left", this._arrowsContainer).css("display", "block");
        $(".right", this._arrowsContainer).css("display", "none");

      } else {
        $(".left", this._arrowsContainer).css("display", "block");
        $(".right", this._arrowsContainer).css("display", "block");
      }
    }

    // Callback
    this.onMoveEnd(this._position);
  };

  this._calculateColumns = function() {
    // Add column classes based on device
    var large = Math.round(12 / this.paneConfig.desktop);
    var medium = Math.round(12 / this.paneConfig.tablet);
    var small = Math.round(12 / this.paneConfig.mobile);

    this._ratios.desktop = large / 12;
    this._ratios.tablet = medium / 12;
    this._ratios.mobile = small / 12;

    for (var i = 0; i < this._nodeList.length; i++) {
      var curNode = this._nodeList[i];
      $(curNode).addClass("large-" + large);
      $(curNode).addClass("medium-" + medium);
      $(curNode).addClass("small-" + small);
    }
  };

  this._onTouchStart = function(e) {
    this._touchStats.x_orig = e.originalEvent.touches[0].clientX;
    this._touchStats.y_orig = e.originalEvent.touches[0].clientY;
    this._touchStats.margin_orig = parseFloat($(this._nodeList[0]).css("margin-left"));

    // reset autoRotate Timer to prevent the timer from rotating after the user clicks
    this._autoRotateInit();
  };

  this._onTouchMove = function(e) {
    var xDifference = e.originalEvent.touches[0].clientX - this._touchStats.x_orig;
    var yDifference = e.originalEvent.touches[0].clientY - this._touchStats.y_orig;

    if (Math.abs(yDifference) > 30 && Math.abs(xDifference) < 20) {
      return;

    } else {
      if (xDifference > 0) {
        this._touchStats.direction = "backward";

      } else {
        this._touchStats.direction = "forward";
      }

      this._touchStats.x_current = this._touchStats.margin_orig + xDifference;
      $(this._nodeList[0]).css("margin-left", this._touchStats.x_current + "px");

      if (Math.abs(xDifference) > 20) {
          e.preventDefault();
      }
    }
  };

  this._onTouchEnd = function(e) {
    this._currentPaneSize = $(this._nodeList[0]).width();
    if (this._touchStats.x_current !== null) {
      var moveHelper = 0.20;
      if (this._touchStats.direction == "backward"){
         moveHelper = -moveHelper;
       }

      var position = Math.round(((-this._touchStats.x_current)/this._currentPaneSize) + moveHelper);
      if (position < 0) {
        position = 0;
      }

      var moveTo = (this._position * this._ratios[this._currentLayout]) * 100;
      if (position >= 0 && position <= this._maxPosition) {
        moveTo = (position * this._ratios[this._currentLayout]) * 100;
        this._position = Math.abs(position);
      }

      // Snap and dots
      $(this._nodeList[0]).animate({
        "margin-left": -moveTo + "%"
      }, {
        queue: false,
        duration: 250,
        easing: "easeOutQuad"
      });

      this._updateDisplay();
    }

    // Reset touch statistics
    this._touchStats.x_orig = null;
    this._touchStats.margin_orig = null;
    this._touchStats.x_current = null;
    this._touchStats.direction = null;
  };
}
